export const validateImportCSV = (dataArray) => {
  if (!dataArray?.[0].length || dataArray[0]?.length < 20) {
    return false;
  }

  return true;
};
